import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export async function safeJson(response: Response): Promise<any> {
  try {
    // Gracefully handle non-Response-like objects passed in by callers
    const anyRes: any = response as any
    const hasHeaders = anyRes && anyRes.headers && typeof anyRes.headers.get === 'function'
    const contentType = hasHeaders ? (anyRes.headers.get('content-type') || '') : ''

    if (hasHeaders && contentType.includes('application/json')) {
      return await (anyRes.json?.() ?? Promise.resolve({}))
    }

    // If no headers or not JSON, but a json() method exists, try it safely
    if (!hasHeaders && typeof anyRes?.json === 'function') {
      return await anyRes.json().catch(() => ({}))
    }

    return {}
  } catch {
    return {}
  }
}

